import experiencesPath from '@glass/common/modules/resumes/paths/experiencesPath';
import { selectResumeValueSelector } from '@glass/web/modules/resumes/selectors';

export const workExperiencePath = (index: number) => `${experiencesPath}[${index}]`;

type CreateSelectWorkExperienceTitle = ({
  eIdx,
}: {
  eIdx: number;
}) => (state: any) => string | undefined;
type Experience = {
  title: string;
};

const createSelectWorkExperienceTitle: CreateSelectWorkExperienceTitle =
  ({ eIdx }) =>
  (state) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const experiences = (selectResumeValueSelector(state, experiencesPath) as Experience[]) || [];
    if (experiences[eIdx]?.title) {
      return experiences[eIdx].title;
    }
    return (experiences.find((experience: Experience) => !!experience?.title) || {}).title;
  };

export default createSelectWorkExperienceTitle;
